import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { pStyles } from '../../typography/new/body';

const TableHeader = ({ headers, isNutritionalTable }) => (
  <tr>
    {headers.map(header => (
      <TableHeading key={header} scope="col">
        {isNutritionalTable && header ? (
          <>
            avg qty
            <br />
            per {header}
          </>
        ) : (
          <>{header}</>
        )}
      </TableHeading>
    ))}
  </tr>
);

const TableHeading = styled.th`
  ${pStyles('extra-small-semi-bold')}
  border-collapse: collapse;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.grey80};
  color: ${({ theme }) => theme.colors.white};
  text-transform: capitalize;
`;

TableHeader.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  isNutritionalTable: PropTypes.bool,
};

TableHeader.defaultProps = {
  isNutritionalTable: false,
};

export { TableHeader };
